import * as Dialog from '@radix-ui/react-dialog';
import Image from "next/image";
import { sortList } from '.';
import { useState } from 'react';


interface OrderByDialogProps {
  orderBy: string
  setOrderBy: (orderBy: string) => void
  // open: boolean;
  // setOpen: (value: boolean) => void;
}

const OrderByDialog = (props: OrderByDialogProps) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleSelectedSort = (sort: string) => {
    if (sort !== props.orderBy) {
      props.setOrderBy(sort)
    }

    setOpen(false);
  }

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <div className="border border-reviewBg border-solid py-1 px-2 flex justify-center items-center space-x-2 rounded-lg" >
          <p className="text-xs text-attributeTitle">Sort By</p>
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/arrow-down.png"}
            alt="arrow icon"
            width={12}
            height={12}
            quality={100}
          />
        </div>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-mobileMask md:bg-desktopMask bg-opacity-50 md:bg-opacity-40 z-[70]" />
        <Dialog.Content className="fixed bottom-0 md:bottom-auto md:top-1/2 md:left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2 bg-white p-8 md:px-20 md:py-12 rounded-t-lg md:rounded-lg w-full md:w-fit md:max-w-1/2 md:min-w-[400px] mx-auto z-[75] outline-none focus:ring-transparent">
          <Dialog.Title />
          <Dialog.Description />
          <div className="bg-white rounded-t-lg md:rounded-lg">
            <div
              className="flex items-center space-x-3"
              onClick={() => setOpen(false)}
            >
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icons/arrow-down.png"}
                alt="arrow icon"
                width={12}
                height={12}
                quality={100}
                className={`transition-transform ease-in-out duration-300 transform rotate-90`}
              />
              <p className="text-sm font-semibold leading-6 text-black">Sort By</p>
            </div>
            <hr className="my-4 bg-reviewBg" />
            {sortList.map((sort, index) => (
              <div
                key={index}
                className={`flex items-center mt-4 space-x-4 cursor-pointer border border-reviewBg border-solid rounded-lg px-4 py-2`}
                onClick={() => handleSelectedSort(sort.value)}
              >
                <input
                  type="radio"
                  id={sort.value}
                  className={`h-4 w-4 rounded-sm border-mooimom text-mooimom cursor-pointer focus:ring-transparent ${props.orderBy === sort.value ? 'bg-mooimom border-transparent' : 'bg-white'}`}
                  checked={props.orderBy === sort.value}
                  onChange={() => handleSelectedSort(sort.value)}
                />
                <p className="text-sm text-black font-semibold">{sort.name}</p>
              </div>
            ))}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export default OrderByDialog
